// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

// Theme configuration
import theme from '../config/theme'

export default createVuetify({
  theme: {
    defaultTheme: 'mission',
    themes: {
      mission: {
        dark: false,
        colors: theme.vuetify,
      },
    },
  },
})
